<template>
	<div class="checkbox">
		<label>
			<input type="checkbox" v-model="val" @change="update"/>
			<div class="text" v-if="label">{{label}}</div>
		</label>
	</div>
</template>

<script>
export default {
	components: {},
	props: {
		value: {type: Boolean, required: false},
		label: {type: String, required: false}
	},
	data() {
		return {
			val: this.value
		}
	},
	methods: {
		update() {
			this.$emit("update", this.val);
		}
	}
};
</script>

<style lang="scss" scoped>
.checkbox {

	label {
		display: flex;

		input {
			display: flex;
			outline: 0;
			flex-shrink: 0;
			width: 1em;
			height: 1em;
			appearance: none;
			background-color: #F5F5F5;
			border: 1px solid #22313A;
			border-radius: 2px;
			margin-right: 1em;

			&:checked {
				&:after {
					display: block;
					$s: 1em;
					width: $s;
					height: $s;
					content: '';
					background-image: url('data:image/svg+xml;charset=US-ASCII,<svg aria-hidden="true" data-prefix="fas" data-icon="check" class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>');
				}
			}
		}

		.text {
			font-size: 12px;
			color: #4A4A4A;
			font-weight: 300;
			line-height: 14px;
		}
	}
}
</style>
